import {KJUR} from 'jsrsasign';

export function sign(data: Record<string, unknown>, key: string): string {
    const kjurToken = KJUR.jws.JWS.sign(null, {alg: 'HS256', typ: 'JWT'} as {alg: string}, data, key);
    return kjurToken;

}

export function unsign(message: string, key: string, opts?: { now?: number }): Record<string, unknown> {
    let kjurResult;
    if (KJUR.jws.JWS.verifyJWT(message, key, {alg: ['HS256'], verifyAt: opts?.now})) {
        kjurResult = KJUR.jws.JWS.parse(message);
    } else {
        throw new Error('invalid jwt token');
    }
    return kjurResult.payloadObj;
}
